import React from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

export const emailsFrom = (p = {}) => {
  const list = (p.emails && p.emails.length ? p.emails : [p.email || ""]).slice(0, 3);
  while (list.length < 3) list.push("");
  return list;
};

export const senderIndexFrom = (p = {}) => {
  const i = emailsFrom(p).findIndex((e) => e && e.toLowerCase() === (p.email || "").toLowerCase());
  return i >= 0 ? i : 0;
};

export default function ProfileEmailsField({ emails, sender, onChange, onSender }) {
  return (
    <div className="space-y-2" data-testid="profile-emails">
      <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email (fino a 3)</Label>
      <p className="text-xs text-slate-500">Seleziona con il pallino l'email su cui i clienti ti rispondono quando ricevono un preventivo.</p>
      {emails.map((e, i) => (
        <div key={`email-slot-${i}`} className="flex items-center gap-3">
          <input
            type="radio"
            name="sender-email"
            aria-label={`Usa l'email ${i + 1} per i preventivi`}
            data-testid={`profile-email-sender-${i}`}
            checked={sender === i}
            disabled={!e.trim()}
            onChange={() => onSender(i)}
            className="w-4 h-4 accent-primary shrink-0 cursor-pointer disabled:cursor-not-allowed"
          />
          <Input
            data-testid={i === 0 ? "profile-email" : `profile-email-${i}`}
            type="email"
            value={e}
            placeholder={i === 0 ? "studio@esempio.it" : "Email aggiuntiva (facoltativa)"}
            onChange={(ev) => onChange(i, ev.target.value)}
          />
        </div>
      ))}
    </div>
  );
}
